export default "__VITE_ASSET__cb9fe95d__"